import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import { HeaderSimple } from 'src/layouts/common';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function CompactLayout({ children }: Props) {
  return (
    <>
      <HeaderSimple />

      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}
